import React from 'react';
import { Row, Col, SvgIcon, Heading } from 'seduo-ui';
export default class Example extends React.Component {
    render() {
        return (<div className="icon-box">
                <Row className="no-gutters">
                    <Col xs="auto" md={12} className="icon-box__icon">
                        <SvgIcon kind="GraduationCapCircle" className="icon-box__svg"/>
                    </Col>
                    <Col xs={7} md={12}>
                        <div className="icon-box__title">
                            <Heading level={3}>100% kontrola vzdělávání</Heading>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        V přehledných reportech nepřetržitě vidíte, jak si vaši zaměstnanci vedou. Získáváte průběžné
                        statistiky, díky kterým se vám bude lépe plánovat další vzdělávání.
                    </Col>
                </Row>
            </div>);
    }
}
